"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterceptError = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const usePrevious_1 = require("./usePrevious");
const useInterceptError = ({ errorStatusesToTrigger, errorSelector, onErrorSideEffect, }) => {
    const selectErrors = (0, react_redux_1.useSelector)(errorSelector, react_fast_compare_1.default);
    const hasError = (0, react_1.useMemo)(() => errorStatusesToTrigger.some((error) => selectErrors.includes(error)), [errorStatusesToTrigger, selectErrors]);
    const hasErrorPrev = (0, usePrevious_1.usePrevious)(hasError);
    (0, react_1.useEffect)(() => {
        if (hasError && hasError !== hasErrorPrev && !!onErrorSideEffect) {
            onErrorSideEffect();
        }
    }, [hasError, hasErrorPrev, onErrorSideEffect]);
};
exports.useInterceptError = useInterceptError;
//# sourceMappingURL=useInterceptError.js.map